import { formatPhoneNumber } from '@clearverify/utils';

import { PeoPayrollProviderInfoFragment } from 'src/api';
import { ClickableLabel, UserStatusChip } from 'src/components/common';
import { DemoPrivacyText } from 'src/components/demoPrivacyMode';
import { TableColumn } from 'src/components/table';
import {
  buildPeoPayrollProviderDetailsUrl,
  getPeoPayrollProviderStatus,
} from 'src/utils/peoPayrollProvider';

const PEO_PAYROLL_PROVIDERS_TABLE_DISPLAY_NAME_COLUMN: TableColumn<PeoPayrollProviderInfoFragment> =
  {
    title: 'Company Name',
    key: 'displayName',
    sortable: true,
    render: (_valueByDataPath, peoPayrollProvider) => {
      return (
        <ClickableLabel
          type="link"
          to={buildPeoPayrollProviderDetailsUrl(peoPayrollProvider.id)}
          label={peoPayrollProvider.displayName}
          logoUrl={peoPayrollProvider.logo?.downloadUrl}
        />
      );
    },
  };

const PEO_PAYROLL_PROVIDERS_TABLE_CONTACT_EMAIL_COLUMN: TableColumn<PeoPayrollProviderInfoFragment> =
  {
    title: 'Contact Email',
    key: 'contactEmail',
    sortable: true,
    render: (_valueByDataPath, peoPayrollProvider) => {
      return <DemoPrivacyText>{peoPayrollProvider.contactEmail}</DemoPrivacyText>;
    },
  };

const PEO_PAYROLL_PROVIDERS_TABLE_CONTACT_PHONE_COLUMN: TableColumn<PeoPayrollProviderInfoFragment> =
  {
    title: 'Contact Phone',
    key: 'contactPhone',
    render: (_valueByDataPath, peoPayrollProvider) => {
      return (
        <DemoPrivacyText>
          {formatPhoneNumber(peoPayrollProvider.contactPhoneNumber)}
        </DemoPrivacyText>
      );
    },
  };

const PEO_PAYROLL_PROVIDERS_TABLE_STATUS_COLUMN: TableColumn<PeoPayrollProviderInfoFragment> = {
  title: 'Status',
  key: 'status',
  render: (_valueByDataPath, peoPayrollProvider) => {
    return <UserStatusChip userStatus={getPeoPayrollProviderStatus(peoPayrollProvider)} />;
  },
};

export const PEO_PAYROLL_PROVIDERS_TABLE_COLUMNS: Array<
  TableColumn<PeoPayrollProviderInfoFragment>
> = [
  PEO_PAYROLL_PROVIDERS_TABLE_DISPLAY_NAME_COLUMN,
  PEO_PAYROLL_PROVIDERS_TABLE_CONTACT_EMAIL_COLUMN,
  PEO_PAYROLL_PROVIDERS_TABLE_CONTACT_PHONE_COLUMN,
  PEO_PAYROLL_PROVIDERS_TABLE_STATUS_COLUMN,
];
